import { formatDate, regexPhoneNumber } from 'helpers/helpers'

// Метки карт доставки: филиал, курьер, клиент. Шар у всех троих собирается здесь,
// иначе они разъезжаются — так у филиала осталось className вместо class, из-за
// чего bootstrap-отступы не применялись и карточка выглядела сжатой.

// Заказ считается «на курьере», пока он не доставлен: 8 — в пути, всё что раньше —
// уже назначено на него. 9 (доставлен) и 10 (закрыт) в счётчик не идут.
export const COURIER_DELIVERED_STATUS = 9

// Имя вставляется в html-строку шара, а не в JSX, поэтому React его не экранирует.
function escapeHtml(value) {
	return String(value ?? '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
}

// Общая раскладка шара: шапка «иконка + название», «иконка + телефон», ниже — строки.
function balloonContent({ icon, name, phone, rows = [] }) {
	return `
		<div class="d-flex flex-column gap-3">
			<div>
				<div class="d-flex gap-2">
					<i class="uil ${icon}"></i>
					<span>${escapeHtml(name)}</span>
				</div>
				<div class="d-flex gap-2">
					<i class="uil uil-phone"></i>
					<span>${escapeHtml(regexPhoneNumber(phone))}</span>
				</div>
			</div>
			${rows.filter(Boolean).join('')}
		</div>
	`
}

// Сколько заказов сейчас на курьере — по списку заказов, который и так на руках
// у карты, отдельный запрос ради счётчика не нужен.
export function countCourierOrders(orders, courierId) {
	if (!courierId) return 0

	let count = 0
	for (const item of (orders ?? [])) {
		if (Number(item.courier_id) !== Number(courierId)) continue
		if (item.status >= COURIER_DELIVERED_STATUS) continue
		count++
	}

	return count
}

export const posPlacemarkOptions = { preset: 'islands#redStretchyIcon' }

// count не обязателен: на карте создания заказа филиалы показываются без счётчика.
export function posPlacemarkProperties({ name, phone, count, t }) {
	return {
		iconContent: escapeHtml(name),
		intContent: t('pos'),
		balloonContent: balloonContent({
			icon: 'uil-restaurant',
			name: name,
			phone: phone,
			rows: [
				Number.isFinite(count) ? `<div>${t('orders')}: <b>${count}</b></div>` : null,
			],
		}),
	}
}

export const courierPlacemarkOptions = { preset: 'islands#darkGreenStretchyIcon' }

// Имя видно сразу, без клика: оператору важно с одного взгляда понять, чья это
// метка. Цифра рядом — сколько заказов на курьере сейчас. Остальное — в шаре.
export function courierPlacemarkProperties({ name, phone, count = 0, updatedAt, t }) {
	return {
		iconContent: count > 0
			? `${escapeHtml(name)} · ${count}`
			: escapeHtml(name),
		intContent: t('courier'),
		balloonContent: balloonContent({
			icon: 'uil-user',
			name: name,
			phone: phone,
			rows: [
				`<div>${t('orders')}: <b>${count}</b></div>`,
				updatedAt ? `<div>${t('updated_at')}: ${formatDate(updatedAt, 'dd.MM.yyyy HH:mm')}</div>` : null,
			],
		}),
	}
}

export function clientPlacemarkProperties({ name, phone, orderId, t }) {
	return {
		intContent: t('client'),
		balloonContent: balloonContent({
			icon: 'uil-user',
			name: name,
			phone: phone,
			rows: [
				orderId ? `<div><b>ID: ${escapeHtml(orderId)}</b></div>` : null,
			],
		}),
	}
}
